module.exports = __webpack_public_path__ + "static/media/Muli-ExtraBold.670ba44c.ttf";